export default function Sparkline({ data, width = 88, height = 28 }) {
    if (!data || data.length < 2) return null;
    const max = Math.max(...data), min = Math.min(...data);
    const range = max - min || 1;
    const pts = data.map((v, i) => {
        const x = (i / (data.length - 1)) * width;
        const y = height - 4 - ((v - min) / range) * (height - 8);
        return `${x.toFixed(1)},${y.toFixed(1)}`;
    }).join(" ");
    const rising = data[data.length - 1] >= data[0];
    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
            <polyline points={pts} stroke={rising ? "#3b82f6" : "#ef4444"} strokeWidth="1.5"
                      fill="none" strokeLinecap="round" strokeLinejoin="round" opacity="0.85"/>
        </svg>
    );
}
